import applyCanvasPatches from "./canvas";

export default () => {
  applyCanvasPatches();
  var searchDiv = document.getElementById("search_amplitudes");
  var searchCtx = searchDiv.getContext("2d");
  var startDiv = document.getElementById("start_search");
  var startCtx = startDiv.getContext("2d");
  var reflectSDiv = document.getElementById("reflect_s");
  var reflectSCtx = reflectSDiv.getContext("2d");
  var reflectEDiv = document.getElementById("reflect_e");
  var reflectECtx = reflectEDiv.getContext("2d");

  // Size of search space, Delta angle, search solution
  const N = 128;
  const Delta = Math.asin(1 / Math.sqrt(N));
  const s = 12;
  const barWidth = 2;
  const totalIterations = Math.round((0.5 * Math.PI - Delta) / (2 * Delta));
  const axisColor = "#999";
  const amplitudeColor = "#aaa";

  // iteration counter: runs from 0 through totalIterations-1
  var i = 0;

  function display(ctx, label, print_iteration, iter, ref_s, ref_e) {
    // Use the context ctx, add a label for s if label is truthy,
    // print the iteration number if print_iteration is truthy, use
    // Grover iteration iter, reflection about the s axis if ref_s is
    // truthy. Reflect about the e axis (and s, implied no matter the
    // value of ref_s) if ref_e is truthy.
    ctx.clear();
    ctx.line(0, 150, xPaint(N) + barWidth, 150, axisColor, 2);
    if (label) {
      ctx.line(xPaint(s), 151, xPaint(s) + 0.5, 153, amplitudeColor, 1);
      ctx.text(label, xPaint(s) - 3, 163, { font: "14px Libre Franklin" });
    }
    if (print_iteration) {
      ctx.text("Grover iteration: " + iter, 0, 190);
    }
    for (var x = 0; x < N; x++) {
      if (x === s) {
        ctx.line(
          xPaint(x),
          yPaint(0),
          xPaint(x),
          yPaint(solutionAmplitude(iter, ref_e)),
          amplitudeColor,
          barWidth,
        );
      } else {
        ctx.line(
          xPaint(x),
          yPaint(0),
          xPaint(x),
          yPaint(nonSolutionAmplitude(iter, ref_s, ref_e)),
          amplitudeColor,
          barWidth,
        );
      }
    }
  }

  function paint() {
    display(searchCtx, "s", true, i, false, false);
    if (i < totalIterations - 1) {
      i++;
    } else {
      i = 0;
    }
    window.setTimeout(function() {
      paint();
    }, 1200);
  }
  paint();

  function startSearch() {
    display(startCtx, "", false, 3, false, false);
  }
  startSearch();

  function reflectS() {
    display(reflectSCtx, "", false, 3, true, false);
  }
  reflectS();

  function reflectE() {
    display(reflectECtx, "", false, 3, true, true);
  }
  reflectE();

  function xPaint(x) {
    // return x position for the amplitude associated to solution
    // x(=0...N-1)
    return x * 4 + 2;
  }

  function yPaint(amp) {
    // return the y position corresponding to the amplitude amp
    return 150 - 140 * amp;
  }

  function angle(iter) {
    // return the angle after iteration iter
    return Delta + 2 * iter * Delta;
  }

  function nonSolutionAmplitude(iter, ref_s, ref_e) {
    // return the amplitude for something which is not an solution,
    // after iteration iter.  If ref_s, then reflect about s. If ref_e
    // then reflect around s and e (regardless of ref_s).
    if (ref_e) {
      return -(Math.cos(angle(iter + 1)) / Math.sqrt(N - 1));
    } else {
      ref_s = ref_s ? -1 : 1;
      return ref_s * (Math.cos(angle(iter)) / Math.sqrt(N - 1));
    }
  }

  function solutionAmplitude(iter, ref_e) {
    // return the amplitude for something which is a solution, after
    // iteration iter. If ref_e then reflect about s and e.
    if (!ref_e) {
      return Math.sin(angle(iter));
    } else {
      return -Math.sin(angle(iter + 1));
    }
  }
};
